var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"cube-list",class:_vm.theme},_vm._l((_vm.list),function(list,index){return _c('li',{key:index,staticClass:"cube-list__item"},[_c('span',{domProps:{"innerHTML":_vm._s(list)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }